import { render, staticRenderFns } from "./CustomerTypeFormModal.vue?vue&type=template&id=3b3b68b1&scoped=true"
import script from "./CustomerTypeFormModal.vue?vue&type=script&lang=js"
export * from "./CustomerTypeFormModal.vue?vue&type=script&lang=js"
import style0 from "./CustomerTypeFormModal.vue?vue&type=style&index=0&id=3b3b68b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3b68b1",
  null
  
)

export default component.exports